/*eslint-disable no-process-env, no-undef */
import React, { Component } from 'react'
import { Switch } from 'react-router-dom'
import Home from './containers/Home'
import HomeTopLeads from './containers/HomeTopLeads'
import AccountSelectorTopLeads from './containers/AccountSelectorTopLeads'
import ReportLoaderTopLeads from './containers/ReportLoaderTopLeads'
import HomeLeadMagnet from './containers/HomeLeadMagnet'
import AdMonitorHome from './containers/AdMonitorHome'
import AdMonitorAccounts from './containers/AdMonitorAccounts'
import AccountSelector from './containers/AccountSelector'
import ReportLoader from './containers/ReportLoader'
import NotFound from './containers/NotFound'
import AppliedRoute from './components/AppliedRoute'
import PropTypes from 'prop-types'
import Unsubscribe from './containers/Unsubscribe'
const { REACT_APP_FACEBOOK_REDIRECT_URI } = process.env

const withTracker = (WrappedComponent, shouldTrackPage/*, options = {}*/) => {
	const trackGa = (formattedPage, shouldTrack) => {
		if(!window.ga) { return }
		window.ga('gtm1.set', 'page', formattedPage)
		if(shouldTrack) {
			window.ga('gtm1.send', 'pageview')
		}
	}
	const trackFb = (fullUrl) => {
		if(!window.fbq) { return }
		window.fbq('trackCustom', 'virtualPageview', {
			url: fullUrl
		})
	}
	const trackPage = page => {
		if(!window.ga) { return } // Google analytics is not active
		const formattedPage = page.replace(/^#/, '').replace(/report\/.*$/, 'report')
		const fullUrl = REACT_APP_FACEBOOK_REDIRECT_URI.replace(/\/$/, '') + formattedPage
		if(!shouldTrackPage) { console.log('shouldTrackPage not defined'); return }
		const shouldTrack = shouldTrackPage(page)
		trackGa(formattedPage, shouldTrack) // GA we set the page regardless
		if(shouldTrack){ trackFb(fullUrl) }
	}

	class HOC extends Component {
		componentDidMount() {
			const page = window.location.hash
			trackPage(page)
		}

		render() {
			return <WrappedComponent {...this.props} />
		}
	}

	return HOC
}


export default function Routes({ childProps, shouldTrackPage }) {

	return (
		<Switch>
			<AppliedRoute path={'/'} exact component={Home} props={childProps} />
			<AppliedRoute path={'/getyourscore'} exact component={HomeTopLeads} props={childProps} />
			<AppliedRoute path={'/getyourscore/accounts'} exact component={withTracker(AccountSelectorTopLeads, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/getyourscore/accounts/err'} exact component={withTracker(AccountSelectorTopLeads, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/getyourscore/report/:accountId'} exact component={withTracker(ReportLoaderTopLeads, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/download/:magnetId'} exact component={HomeLeadMagnet} props={childProps} />
			<AppliedRoute path={'/accounts'} exact component={withTracker(AccountSelector, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/accounts/err'} exact component={withTracker(AccountSelector, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/report/:accountId'} exact component={withTracker(ReportLoader, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/admonitor'} exact component={withTracker(AdMonitorHome, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/admonitor/renew/:email'} exact component={withTracker(AdMonitorHome, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/admonitor/accounts'} exact component={withTracker(AdMonitorAccounts, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/admonitor/accounts/reauth'} exact component={withTracker(AdMonitorAccounts, shouldTrackPage)} props={childProps} />
			<AppliedRoute path={'/admonitor/unsubscribe/:unsubscribeToken/:accountId'} exact component={withTracker(Unsubscribe, shouldTrackPage)} props={childProps} />
			<AppliedRoute component={withTracker(NotFound)} props={childProps} />
		</Switch>
	)
}

Routes.propTypes = {
	childProps: PropTypes.object,
	shouldTrackPage: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/Routes.js